import { all, call, put, takeEvery, select } from 'redux-saga/effects'
import { globalLoaderText } from "redux/CommonDashboard/actions";
import api from "../../client/utils/clientApiHelper";
import * as AssetSubTypeType from '../../Store/AssetManagement/AssetNumber/AssetNumberType'
import { setAssetNumberValue, setTransferAssetDetails, setAssetError, setReactivationAssetDetails, setFleetAssetValidation } from 'Store/AssetManagement/AssetNumber/AssetNumberAction';
import { CONSTANTS } from 'client/utils/constants';
import { API_URL, apiMethod, apiType } from 'utils';
import { IPayload } from 'Model/IPayload';

const numberval = (response: any) => {
  if (response?.frsOrderNumber != null && response?.leadrOrderNumber != null) {
    return ("FRS # " + response?.frsOrderNumber + ", " + "LEADR # " + response?.leadrOrderNumber)
  } else if (response?.frsOrderNumber != null) {
    return ("FRS # " + response?.frsOrderNumber)
  } else if (response?.leadrOrderNumber != null) {
    return ("LEADR # " + response?.leadrOrderNumber)
  }
}

function* getAssetNumberValue(req: any): any {
  try {
    yield put(globalLoaderText("Fetching Asset Detail..."));
    if (req?.val?.assetNumber?.toString().length > 0 && req?.val?.assetNumber?.toString()?.replaceAll("0", "").length > 0) {
      let isValidLocally = true;
      let count = 0;
      if (req.val.requestType == CONSTANTS?.REQUISITION) {
        const reason = yield select(
          (state: any) => state.RequisitionReducer.reasonList
        );
        reason?.forEach((x: any, _index: any) => {
          if ((String(x?.asset) === String(req?.val?.assetNumber))) {
            count = count + 1
          }
          if (count > 1) {
            isValidLocally = false;
          }
        });
      } else {
        const assetreason = yield select(
          (state: any) => state?.TransferReducer?.allCartAsset
        );
        let count = 0
        assetreason?.forEach((x: any, _index: any) => {
          if ((String(x?.assetNumber) === String(req?.val?.assetNumber))) {
            count = count + 1
          }
        });
        if(count >= 2){
          isValidLocally = false
        }
      }
      let payloadData : IPayload = {
        apiType : apiType.AssetManagement,
        endpoint : `assets/validate`,
        apiMethod :  apiMethod.POST,
        payload : req?.val
    }
      
      
      const response = yield call(
        api.callAssetPost,
        API_URL.PostWebApp, payloadData
      );
      if (isValidLocally) {
        if (req.val.requestType == CONSTANTS?.REQUISITION) {
          if (response?.asset) {
            yield put(
              setAssetNumberValue({
                res: response?.asset,
                id: req.val.assetNumber
              })
            );
            yield put(setAssetError({ assetNumber: 0, assetError: response?.validationMessage}));
          } else {
            if(response?.frsOrderNumber != null || response?.leadrOrderNumber != null){
              yield put(setAssetError({ assetNumber: req?.val?.assetNumber, assetError: "Replaced Asset # must not be pending approval or in fleet processing for another Request" + " " + numberval(response) }));
            }else{
              yield put(setAssetError({ assetNumber: req?.val?.assetNumber, assetError: response?.validationMessage }));
            }
          }
        } else{
          if (response?.asset) {
            if(req.val.requestType == CONSTANTS?.REACTIVATION){
              yield put(setReactivationAssetDetails(response?.asset));
            }else{
              yield put(setTransferAssetDetails({...response?.asset, showAssetStatus: response?.showAssetStatus}));
            }
            yield put(setAssetError({ assetNumber: req?.val?.assetNumber, assetError: "" }));
          } else {
            if(response?.frsOrderNumber != null || response?.leadrOrderNumber != null){
              yield put(setAssetError({ assetNumber: req?.val?.assetNumber, assetError: "Asset # must not be pending approval or in fleet processing for another Request" + " " + numberval(response) }));
            }else{
              yield put(setAssetError({ assetNumber: req?.val?.assetNumber, assetError: response?.validationMessage }));
            }
            if(req.val.requestType == CONSTANTS?.REACTIVATION){
              yield put(setReactivationAssetDetails({}));
            }else{
              yield put(setTransferAssetDetails({}));
            }
          }

        }
      } else {
        if (req.val.requestType == CONSTANTS?.REQUISITION) {
          yield put(setAssetError({ assetNumber: req?.val?.assetNumber, assetError:  "The Replaced Asset you have chosen is already associated with other item in this request. Please enter a new replaced asset number that is not been associated." }));
        }
         else {
          if(req.val.requestType == CONSTANTS?.REACTIVATION){
            yield put(setReactivationAssetDetails({}));
          }else{
            yield put(setTransferAssetDetails({}));
          }
          yield put(setAssetError({ assetNumber: req?.val?.assetNumber, assetError: "The Asset you have chosen is already associated with other item in this request. Please enter a new asset number that is not been associated."}));
        }
      }
      yield put(globalLoaderText(""));

    }else{
      if (req.val.requestType == CONSTANTS?.REQUISITION) {
        yield put(setAssetError({ assetNumber: req?.val?.assetNumber, assetError: "Please enter valid Replaced Asset No"}));
      }
      else {
        if(req.val.requestType == CONSTANTS?.REACTIVATION){
          yield put(setReactivationAssetDetails({}));
        }else{
          yield put(setTransferAssetDetails({}));
        }
        yield put(setAssetError({ assetNumber: req?.val?.assetNumber, assetError:"Please enter Valid Asset #"}))
      }
      yield put(globalLoaderText(""));
    }
  }
  catch (error) {
    if (req.val.requestType == CONSTANTS?.REQUISITION) {
      yield put(setAssetError({ assetNumber: req?.val?.assetNumber, assetError: "Please enter valid Replaced Asset No"}));
    }
    else {
      if(req.val.requestType == CONSTANTS?.REACTIVATION){
        yield put(setReactivationAssetDetails({}));
      }else{
        yield put(setTransferAssetDetails({}));
      }
      yield put(setAssetError({ assetNumber: req?.val?.assetNumber, assetError:"Please enter Valid Asset #"}))
    }
    yield put(globalLoaderText(""));
  }

}

function* getPurchaseDetailAssetValidation(req: any): any {
  try {
    yield put(globalLoaderText("Getting Asset details...."));
    let payloadData : IPayload = {
      apiType : apiType.AssetManagement,
      endpoint : `assets/validate/fleet/assets`,
      apiMethod :  apiMethod.POST,
      payload : req.assetNumber
     }
    const response = yield call(
      api.callAssetPost, API_URL.PostWebApp, payloadData      
      );
      yield put(globalLoaderText(""));
      yield put(setFleetAssetValidation(response));
  } catch (error: any) {
    yield put(globalLoaderText(""));
    yield put(setFleetAssetValidation([{validationMessage: "Please enter valid Asset #", isValid: false}]))
  }
}

function* watchGetAssetNumberTypes() {
  yield takeEvery(AssetSubTypeType.GET_ASSET_NUMBER_VALUE, getAssetNumberValue)
  yield takeEvery(AssetSubTypeType.GET_FLEET_ASSET_VALIDATION, getPurchaseDetailAssetValidation)
}

export default function* combinedSaga() {
  yield all([
    watchGetAssetNumberTypes()
  ])
}
